import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, ViewChild, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootPrintPortalManager_ShellService } from './FootPrintPortalManager.shell.service';
import { FootPrintPortalManager_OperationService } from './FootPrintPortalManager.operation.service';
import { FootPrintPortalManager_DatasourceService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_FlowService } from './FootPrintPortalManager.flow.index';
import { FootPrintPortalManager_ReportService } from './FootPrintPortalManager.report.index';
import { FootPrintPortalManager_LocalizationService } from './FootPrintPortalManager.localization.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootPrintPortalManager.frontend.types'
import { $frontendTypes as $types} from './FootPrintPortalManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';



interface IFootPrintPortalManager_inventory_pallet_gridComponentEntity {
LicensePlateId?: number, LotId?: number, PackagedId?: number, GrossWeight?: number, PackagedAmount?: number, Lot?: { LookupCode?: string, MaterialId?: number, ReceiveDate?: string, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string, ProjectId?: number, Project?: { LookupCode?: string } } }, Packaging?: { ShortName?: string }, LicensePlate?: { LookupCode?: string, ParentId?: number, TypeId?: number, Location?: { Id?: number, Name?: string, Warehouse?: { Id?: number, Name?: string } }, ParentLicensePlate?: { Id?: number, LookupCode?: string } }, WeightUom?: { Short_name?: string }, inbound_order?: { OrderId?: number, LotId?: number, ActualTargetLicensePlateId?: number, order?: { Id?: number, LookupCode?: string } }, lot_availability?: { TotalAvailablePackagedAmount?: number }}

interface IFootPrintPortalManager_inventory_pallet_gridComponentInParams {
  licenseplateId?: number, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[]}


class FootPrintPortalManager_inventory_pallet_gridComponentRowModel extends GridRowModel {
  grid: FootPrintPortalManager_inventory_pallet_gridComponent;
  entity: IFootPrintPortalManager_inventory_pallet_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    material: new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    lot: new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    licenseplate: new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    material_name: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    material_description: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    total_packaged_amount: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    available_packaged_amount: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    packaging: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    warehouse: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    project: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    gross_weight: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    weight_uom: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    inbound_order: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    vendor_lot: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    expiration_date: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    manufacture_date: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
    received_date: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null, null, null, null)
,
null
      ),
  }



  constructor(
    private utils: UtilsService,
private settings: SettingsValuesService,
private shell: FootPrintPortalManager_ShellService,
private datasources: FootPrintPortalManager_DatasourceService,
private flows: FootPrintPortalManager_FlowService,
private reports: FootPrintPortalManager_ReportService,
private localization: FootPrintPortalManager_LocalizationService,
private operations: FootPrintPortalManager_OperationService,
private logger: CleanupLoggerService,
) {
    super();
    
  }

  async $initializeExisting(grid: FootPrintPortalManager_inventory_pallet_gridComponent, entity: IFootPrintPortalManager_inventory_pallet_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.entity = entity;

    this.rowId = [this.entity.LicensePlateId,this.entity.LotId,this.entity.PackagedId].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(grid: FootPrintPortalManager_inventory_pallet_gridComponent, entity?: IFootPrintPortalManager_inventory_pallet_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.LicensePlateId,this.entity.LotId,this.entity.PackagedId].join('-');
    this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    const $resultKey = {};
    set($resultKey, 'LicensePlateId',this.entity.LicensePlateId);
    set($resultKey, 'LotId',this.entity.LotId);
    set($resultKey, 'PackagedId',this.entity.PackagedId);
    const inParams = {
      $keys:[$resultKey],
      licenseplateId:  $grid.inParams.licenseplateId ,
      fullTextSearch:  $grid.fullTextSearch ,
      ownerId:  $grid.inParams.ownerId ,
      projectId:  $grid.inParams.projectId ,
      warehouseId:  $grid.inParams.warehouseId ,
      materialIds:  $grid.inParams.materialIds ,
      licenseplateStatusId:  null ,
      lotStatusId:  null ,
      vendorlotTextSearch:  null ,
      take:  null ,
      skip:  null ,
    };
    const data = await this.datasources.FootPrintPortalManager.ds_inventory_pallet_grid.getByKeys(inParams);
    this.entity = data.result[0];
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    (this.cells.material.displayControl as TextModel).text = $row.entity.Lot?.Material?.LookupCode;
    (this.cells.lot.displayControl as TextModel).text = $row.entity.Lot?.LookupCode;
    (this.cells.licenseplate.displayControl as TextModel).text = $row.entity.LicensePlate.LookupCode;
    (this.cells.material_name.displayControl as TextModel).text = $row.entity.Lot?.Material?.Name;
    (this.cells.material_description.displayControl as TextModel).text = $row.entity.Lot?.Material?.Description;
    (this.cells.total_packaged_amount.displayControl as TextModel).text = $row.entity.PackagedAmount?.toString();
    (this.cells.available_packaged_amount.displayControl as TextModel).text = $row.entity.lot_availability?.TotalAvailablePackagedAmount?.toString();
    (this.cells.packaging.displayControl as TextModel).text = $row.entity.Packaging?.ShortName;
    (this.cells.warehouse.displayControl as TextModel).text = $row.entity.LicensePlate?.Location?.Warehouse?.Name;
    (this.cells.project.displayControl as TextModel).text = $row.entity.Lot?.Material?.Project?.LookupCode;
    (this.cells.gross_weight.displayControl as TextModel).text = $row.entity.GrossWeight?.toString();
    (this.cells.weight_uom.displayControl as TextModel).text = $row.entity.WeightUom?.Short_name;
    (this.cells.inbound_order.displayControl as TextModel).text = $row.entity.inbound_order?.order?.LookupCode;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'material' : {
        this.on_material_clicked();
        break;
      }
      case 'lot' : {
        this.on_lot_clicked();
        break;
      }
      case 'licenseplate' : {
        this.on_licenseplate_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_lot_clicked(event = null) {
    return this.on_lot_clickedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lot_clickedInternal(
    $row: FootPrintPortalManager_inventory_pallet_gridComponentRowModel,
  $grid: FootPrintPortalManager_inventory_pallet_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  
  
  
  
  if (await $operations.FootPrintPortalManager.Disable_Lot_Management.isAuthorized()) {
      $shell.FootPrintPortalManager.openInfoDialog('Lot management', 'You are not authorized the view and manage the lot')
  }
  else {
  
    $shell.FootPrintPortalManager.opensingle_lot_hub({lotId: $row.entity.LotId});
  }
  
  
  }
  on_material_clicked(event = null) {
    return this.on_material_clickedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_material_clickedInternal(
    $row: FootPrintPortalManager_inventory_pallet_gridComponentRowModel,
  $grid: FootPrintPortalManager_inventory_pallet_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  
  
  
  
  
  if (await $operations.FootPrintPortalManager.Disable_Material_Management.isAuthorized()) {
      $shell.FootPrintPortalManager.openInfoDialog('Material management', 'You are not authorized the view and manage the material')
  }
  else {
  
      $shell.FootPrintPortalManager.opensingle_material_hub({ materialId: $row.entity.Lot.MaterialId });
  }
  
  
  
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootPrintPortalManager_inventory_pallet_gridComponentRowModel,
  $grid: FootPrintPortalManager_inventory_pallet_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  // Apply date format
  if ($utils.isDefined($row.entity.Lot?.VendorLot?.ExpirationDate) && $utils.isDefined($settings.FootPrintPortalManager.DateFormat)) {
      var dateFormat = $settings.FootPrintPortalManager.DateFormat;
      var expirationDate = $utils.date.format($row.entity.Lot?.VendorLot?.ExpirationDate, dateFormat);
      $row.cells.expiration_date.displayControl.text = expirationDate;
  }
  
  
  if ($utils.isDefined($row.entity.Lot?.VendorLot?.ManufactureDate) && $utils.isDefined($settings.FootPrintPortalManager.DateFormat)) {
      var dateFormat = $settings.FootPrintPortalManager.DateFormat;
      var manufactureDate = $utils.date.format($row.entity.Lot?.VendorLot?.ManufactureDate, dateFormat);
      $row.cells.manufacture_date.displayControl.text = manufactureDate;
  }
  
  
  if ($utils.isDefined($row.entity.Lot?.ReceiveDate) && $utils.isDefined($settings.FootPrintPortalManager.DateFormat)) {
      var dateFormat = $settings.FootPrintPortalManager.DateFormat;
      var receivedDate = $utils.date.format($row.entity.Lot?.ReceiveDate, dateFormat);
      $row.cells.received_date.displayControl.text = receivedDate;
  }
  
  if ($utils.isDefined($row.entity.Lot?.VendorLot?.Vat)) {
  
      $row.cells.vendor_lot.displayControl.text = $row.entity.Lot?.VendorLot?.LookupCode + ' ' + $row.entity.Lot?.VendorLot?.Vat
  } else {
      $row.cells.vendor_lot.displayControl.text = $row.entity.Lot?.VendorLot?.LookupCode
  }
  }
  on_licenseplate_clicked(event = null) {
    return this.on_licenseplate_clickedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_licenseplate_clickedInternal(
    $row: FootPrintPortalManager_inventory_pallet_gridComponentRowModel,
  $grid: FootPrintPortalManager_inventory_pallet_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  
  
  
  if (await $operations.FootPrintPortalManager.Disable_Pallet_Management.isAuthorized()) {
      $shell.FootPrintPortalManager.openInfoDialog('Pallet management', 'You are not authorized the view and manage the pallet')
  }
  else {
  
      if ($utils.isDefined($row.entity.LicensePlateId)) {
          $shell.FootPrintPortalManager.opensingle_pallet_hub({ licenseplateId: $row.entity.LicensePlateId });
      }
  }
  
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootPrintPortalManager-inventory_pallet_grid',
  templateUrl: './FootPrintPortalManager.inventory_pallet_grid.component.html'
})
export class FootPrintPortalManager_inventory_pallet_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootPrintPortalManager_inventory_pallet_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootPrintPortalManager_inventory_pallet_gridComponentInParams = { licenseplateId: null, ownerId: null, projectId: null, warehouseId: null, materialIds: [] };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     material: new GridHeaderModel(new HeaderStyles(null, null), 'Material', false, false, null),       lot: new GridHeaderModel(new HeaderStyles(null, null), 'Lot', false, false, null),       licenseplate: new GridHeaderModel(new HeaderStyles(null, null), 'Pallet', false, false, null),       material_name: new GridHeaderModel(new HeaderStyles(null, null), 'Material name', false, false, null),       material_description: new GridHeaderModel(new HeaderStyles(null, null), 'Material description', false, false, null),       total_packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'Total amount', false, false, null),       available_packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'Available amount', false, false, null),       packaging: new GridHeaderModel(new HeaderStyles(null, null), 'Packaging', false, false, null),       warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'Warehouse', false, false, null),       project: new GridHeaderModel(new HeaderStyles(null, null), 'Project', false, false, null),       gross_weight: new GridHeaderModel(new HeaderStyles(null, null), 'Gross weight', false, false, null),       weight_uom: new GridHeaderModel(new HeaderStyles(null, null), 'Weight UOM', false, false, null),       inbound_order: new GridHeaderModel(new HeaderStyles(null, null), 'Receiving order', false, false, null),       vendor_lot: new GridHeaderModel(new HeaderStyles(null, null), 'Vendor lot', false, false, null),       expiration_date: new GridHeaderModel(new HeaderStyles(null, null), 'Expiration date', false, false, null),       manufacture_date: new GridHeaderModel(new HeaderStyles(null, null), 'Manufacture date', false, false, null),       received_date: new GridHeaderModel(new HeaderStyles(null, null), 'Received date', false, false, null),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootPrintPortalManager_inventory_pallet_gridComponentRowModel[] = [];
  @ViewChild('$gridComponent', { read:  GridComponent}) $gridComponent: GridComponent;

  @Input('licenseplateId') set $inParams_licenseplateId(value: any) {
    this.inParams['licenseplateId'] = value;
  }
  get $inParams_licenseplateId(): any {
    return this.inParams['licenseplateId'] ;
  }
  @Input('ownerId') set $inParams_ownerId(value: any) {
    this.inParams['ownerId'] = value;
  }
  get $inParams_ownerId(): any {
    return this.inParams['ownerId'] ;
  }
  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }
  @Input('warehouseId') set $inParams_warehouseId(value: any) {
    this.inParams['warehouseId'] = value;
  }
  get $inParams_warehouseId(): any {
    return this.inParams['warehouseId'] ;
  }
  @Input('materialIds') set $inParams_materialIds(value: any) {
    this.inParams['materialIds'] = value;
  }
  get $inParams_materialIds(): any {
    return this.inParams['materialIds'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };



  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    private shell: FootPrintPortalManager_ShellService,
    private datasources: FootPrintPortalManager_DatasourceService,
    private flows: FootPrintPortalManager_FlowService,
    private reports: FootPrintPortalManager_ReportService,
    private localization: FootPrintPortalManager_LocalizationService,
    private operations: FootPrintPortalManager_OperationService,
    private logger: CleanupLoggerService,
    ) {
    super();
    this.title = 'Inventory by pallet';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.utils;

    this.pageSize = 100;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  $rowPropertyChangeCallback (source: GridRowModel, property: string): void {
    if (property === 'selected') {
      this.$gridComponent.updateAllSelected();
    }
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      licenseplateId:  $grid.inParams.licenseplateId ,
      fullTextSearch:  $grid.fullTextSearch ,
      ownerId:  $grid.inParams.ownerId ,
      projectId:  $grid.inParams.projectId ,
      warehouseId:  $grid.inParams.warehouseId ,
      materialIds:  $grid.inParams.materialIds ,
      licenseplateStatusId:  null ,
      lotStatusId:  null ,
      vendorlotTextSearch:  null ,
      take:  null ,
      skip:  null ,
    };
    try {
    const data = await this.datasources.FootPrintPortalManager.ds_inventory_pallet_grid.getList(inParams);
      this.entities = data.result;
      this.totalCount = data.totalCount;
      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootPrintPortalManager_inventory_pallet_gridComponentRowModel(
          this.utils,
          this.settings,
          this.shell, 
          this.datasources,
          this.flows,
          this.reports,
          this.localization,
          this.operations,
          this.logger);
        rowLoadPromises.push( row.$initializeExisting(this, entity, this.$rowPropertyChangeCallback.bind(this)));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_grid_data_loaded();
  }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootPrintPortalManager_inventory_pallet_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  }
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: FootPrintPortalManager_inventory_pallet_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  const hasOneSelectedRows = $grid.selectedRows.length === 1;
  
  }
  on_grid_data_loaded(event = null) {
    return this.on_grid_data_loadedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_grid_data_loadedInternal(
    $grid: FootPrintPortalManager_inventory_pallet_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  }
  on_export_flow(event = null) {
    return this.on_export_flowInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_export_flowInternal(
    $grid: FootPrintPortalManager_inventory_pallet_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  
  const exportLimit = $settings.FootPrintPortalManager.ExcelExportLimit
  var topLimit: number = 5000;
  
  // Initialize
  var wb = $event;
  var transactions = [];
  var allData: any[] = [];
  var lot_availability: any[] = [];
  var inboundOrders: any[] = [];
  var freshData: any[] = [];
  
  // Set Date/Time Formats
  const dateFormat = `${$settings.FootPrintPortalManager.DateFormat}`;
  
  
  try {
      //Handle user selected rows only. 
  
      if ($grid.selectedRows.length > 0) {
  
          let lotIds = [...new Set($grid.selectedRows.map(r => r.entity?.LotId))]
          let packagedIds = [...new Set($grid.selectedRows.map(r => r.entity?.PackagedId))]
          let licenseplateIds = [...new Set($grid.selectedRows.map(r => r.entity?.LicensePlateId))]
  
  
  
  
          let lot_availability = (await $datasources.Inventory.ds_get_available_inventory_by_licenseplateIds_lotIds_packagedIds_batched.get({
              lotIds: lotIds, packagedIds: packagedIds, licenseplateIds: licenseplateIds
          })).result;
          let inboundOrders = (await $datasources.Inventory.ds_get_lot_original_inbound_order_batched.get({ lotIds: lotIds })).result
  
          // Compile all data into JSON
          for (let row of $grid.selectedRows) {
  
              transactions.push({
                  "LP": row.entity.LicensePlate.LookupCode,
                  "Location": row.entity.LicensePlate?.Location?.Name,
                  "Warehouse": row.entity.LicensePlate?.Location?.Warehouse?.Name,
                  "Project": row.entity.Lot?.Material?.Project?.LookupCode,
                  "Material": row.entity.Lot?.Material?.LookupCode,
                  "Lot": row.entity.Lot?.LookupCode,
                  "Total Amount": row.entity.PackagedAmount,
                  "Available Amount": lot_availability.find(e => e?.LotId === row.entity?.LotId
                      && e?.LicensePlateId === row.entity?.LicensePlateId
                      && e?.PackagedId === row.entity?.PackagedId)?.TotalAvailablePackagedAmount.toString(),
                  "Packaging": row.entity.Packaging?.ShortName,
                  "Gross Weight": row.entity.GrossWeight,
                  "Weight Uom": row.entity.WeightUom?.Short_name,
                  "Inbound Order": inboundOrders.find(e => e?.LotId === row.entity?.LotId)?.order?.LookupCode,
                  "Vendor Lot": row.entity.Lot?.VendorLot?.LookupCode,
                  "Expiration Date": $utils.date.format(row.entity.Lot?.VendorLot?.ExpirationDate, dateFormat),
                  "Manufacture Date": $utils.date.format(row.entity.Lot?.VendorLot?.ManufactureDate, dateFormat),
                  "Received Date": $utils.date.format(row.entity.Lot?.ReceiveDate, dateFormat),
                  "Material Description": row.entity.Lot?.Material?.Description
  
              });
          }
          var ws = $utils.excel.json_to_sheet(transactions);
          $utils.excel.book_append_sheet(wb, ws, "InventoryExport");
      }
      //take all rows in the dataset with applied filters.
      else {
  
          var totalRecords = (await $datasources.Inventory.ds_inventory_licenseplate_grid.get({
              ownerId: $grid.inParams.ownerId,
              projectId: $grid.inParams.projectId,
              warehouseId: $grid.inParams.warehouseId,
              materialIds: $grid.inParams.materialIds,
              fullTextSearch: $grid.fullTextSearch
          })).totalCount;
  
  
          if (totalRecords > exportLimit) {
              var exportApproval = true;
              (await $shell.Inventory.openInfoDialog(`Export limitation of ${exportLimit} exceeded`, `Excel will only export ${exportLimit} records`));
          } else {
              exportApproval = true;
          }
  
  
          if (exportApproval) {
              var recordsTaken: number = 0;
              var remainingRecords: number = Math.min(exportLimit, totalRecords);
              do {
                  var response = await $datasources.Inventory.ds_inventory_licenseplate_grid.get({
                      ownerId: $grid.inParams.ownerId,
                      projectId: $grid.inParams.projectId,
                      warehouseId: $grid.inParams.warehouseId,
                      materialIds: $grid.inParams.materialIds,
                      fullTextSearch: $grid.fullTextSearch
                  });
                  allData = allData.concat(response.result);
                  recordsTaken += response.result.length
                  remainingRecords -= response.result.length
  
              } while (remainingRecords > 0 && response.result.length > 0)
  
              // Compile all data into JSON
              for (let record of allData) {
  
  
  
                  transactions.push({
                      "LP": record.LicensePlate?.LookupCode,
                      "Location": record.LicensePlate?.Location?.Name,
                      "Warehouse": record.LicensePlate?.Location?.Warehouse?.Name,
                      "Project": record.Lot?.Material?.Project?.LookupCode,
                      "Material": record.Lot?.Material?.LookupCode,
                      "Lot": record.Lot?.LookupCode,
                      "Total Amount": record.PackagedAmount,
                      "Available Amount": record.lot_availability?.TotalAvailablePackagedAmount,
                      "Packaging": record.Packaging?.ShortName,
                      "Gross Weight": record.GrossWeight,
                      "Weight Uom": record.WeightUom?.Short_name,
                      "Inbound Order": record.inbound_order?.order?.LookupCode ?? record.Lot?.LookupCode,
                      "Vendor Lot": record.Lot?.VendorLot?.LookupCode,
                      "Expiration Date": $utils.date.format(record.Lot?.VendorLot?.ExpirationDate, dateFormat),
                      "Manufacture Date": $utils.date.format(record.Lot?.VendorLot?.ManufactureDate, dateFormat),
                      "Received Date": $utils.date.format(record.Lot?.ReceiveDate, dateFormat),
                      "Material Description": record.Lot?.Material?.Description
                  });
              }
              var ws = $utils.excel.json_to_sheet(transactions);
              $utils.excel.book_append_sheet(wb, ws, "InventoryExport");
          }
      }
  
  } catch (error) {
      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
      throw new Error(errorMessage);
  }
  
  }
  //#endregion private flows


  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_export_flow(wb);

    writeExcelFile(wb, 'FootPrintPortalManager_inventory_pallet_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
